import {
  difference,
  filter,
  find,
  flatten,
  get,
  isEmpty,
  isNil,
  map,
  omit,
  some,
} from 'lodash'

import { areSameValue, uniquePrimitives } from '../../core/utils'

const getExcludedByIngredientOriginalType = (result, itemId) => {
  const excludedByIngredient = find(result, ({ id: excludedById }) =>
    areSameValue(itemId, excludedById),
  )

  if (isNil(excludedByIngredient)) {
    return 'DEFINITE'
  }

  if (excludedByIngredient.type === 'DEFINITE') {
    return getExcludedByIngredientOriginalType(
      result,
      excludedByIngredient.excludedById,
    )
  }

  return excludedByIngredient.type
}

const recursivelyGetOwnerIngredientNodes = ({
  ingredientIds,
  ownerIngredientsGroupedByComponentIngredientId,
  result,
}) => {
  if (
    isEmpty(ingredientIds) ||
    isEmpty(ownerIngredientsGroupedByComponentIngredientId)
  ) {
    return result
  }

  const wholeIngredientIdsUsedAsComponents = filter(
    ingredientIds,
    id => !isNil(get(ownerIngredientsGroupedByComponentIngredientId, id)),
  )

  const ownerIngredientsNodes = flatten(
    map(wholeIngredientIdsUsedAsComponents, id => {
      const ownerIngredients = get(
        ownerIngredientsGroupedByComponentIngredientId,
        id,
      )

      return map(ownerIngredients, ownerIngredient => {
        const ing =
          find(
            ownerIngredient.componentIngredients,
            ({ id: componentIngredientId }) => componentIngredientId === id,
          ) || {}

        const excludedByIngredientType = getExcludedByIngredientOriginalType(
          result,
          id,
        )

        return {
          ...ownerIngredient,
          isManualSelection: false,
          excludedById: id,
          originalTypeOfWhole: excludedByIngredientType,
          type: ing.type,
        }
      })
    }),
  )

  const newResult = [...result, ...ownerIngredientsNodes]

  const ownerIngredientIds = difference(
    uniquePrimitives(
      map(
        filter(
          ownerIngredientsNodes,
          ({ componentIngredients, id }) =>
            !isEmpty(componentIngredients) &&
            !some(result, ({ id: nodeId }) => areSameValue(nodeId, id)),
        ),
        'id',
      ),
    ),
    ingredientIds,
  )

  return recursivelyGetOwnerIngredientNodes({
    ingredientIds: ownerIngredientIds,
    ownerIngredientsGroupedByComponentIngredientId: omit(
      ownerIngredientsGroupedByComponentIngredientId,
      wholeIngredientIdsUsedAsComponents,
    ),
    result: newResult,
  })
}

export default recursivelyGetOwnerIngredientNodes
